// Безопасный маппер для enum'ов
// Обрабатывает случаи когда в базе данных есть значения, которых нет в enum'ах

import { PositionStatusEnum } from '../../generated-src/client/positions/api';
import { InterviewStatusEnum } from '../../generated-src/client/interviews/api';
import { InterviewResultEnum } from '../../generated-src/client/interviews/api';
// QuestionTypeEnum удален из нового API
import { ListAccountsRole } from '../../generated-src/client/account/api';

// Используем сгенерированный RoleEnum
const RoleEnum = ListAccountsRole;

// Удалить все, что связано с SourceEnum и маппингом поля source.



// Безопасный маппер для PositionStatusEnum
export function mapPositionStatusEnum(value: string | null | undefined): PositionStatusEnum {
  if (!value) return PositionStatusEnum.ACTIVE;

  const normalized = value.toUpperCase();

  switch (normalized) {
    case 'ACTIVE':
      return PositionStatusEnum.ACTIVE;
    case 'PAUSED':
      return PositionStatusEnum.PAUSED;
    case 'ARCHIVED':
      return PositionStatusEnum.ARCHIVED;
    default:
      console.warn(`Unknown position status: "${value}", mapping to ACTIVE`);
      return PositionStatusEnum.ACTIVE;
  }
}

// Безопасный маппер для InterviewStatusEnum
export function mapInterviewStatusEnum(value: string | null | undefined): InterviewStatusEnum {
  if (!value) return InterviewStatusEnum.NOT_STARTED;

  const normalized = value.toUpperCase();

  switch (normalized) {
    case 'NOT_STARTED':
      return InterviewStatusEnum.NOT_STARTED;
    case 'IN_PROGRESS':
      return InterviewStatusEnum.IN_PROGRESS;
    case 'FINISHED':
      return InterviewStatusEnum.FINISHED;
    case 'LIMIT_EXHAUSTED':
      return InterviewStatusEnum.LIMIT_EXHAUSTED;
    default:
      console.warn(`Unknown interview status: "${value}", mapping to NOT_STARTED`);
      return InterviewStatusEnum.NOT_STARTED;
  }
}

// Безопасный маппер для InterviewResultEnum
export function mapInterviewResultEnum(value: string | null | undefined): InterviewResultEnum | undefined {
  if (!value) return undefined;

  const normalized = value.toUpperCase();

  switch (normalized) {
    case 'SUCCESSFUL':
      return InterviewResultEnum.SUCCESSFUL;
    case 'UNSUCCESSFUL':
      return InterviewResultEnum.UNSUCCESSFUL;
    case 'ERROR':
      return InterviewResultEnum.ERROR;
    default:
      console.warn(`Unknown interview result: "${value}", returning undefined`);
      return undefined;
  }
}

// Безопасный маппер для RoleEnum
export function mapRoleEnum(value: string | null | undefined): typeof RoleEnum[keyof typeof RoleEnum] {
  if (!value) return RoleEnum.RECRUITER;

  const normalized = value.toUpperCase();

  switch (normalized) {
    case 'ADMIN':
      return RoleEnum.ADMIN;
    case 'RECRUITER':
      return RoleEnum.RECRUITER;
    default:
      console.warn(`Unknown role: "${value}", mapping to RECRUITER`);
      return RoleEnum.RECRUITER;
  }
}

// QuestionTypeEnum удален из нового API - все вопросы теперь текстовые

// Универсальный маппер для всех enum'ов
export function safeMapEnum<T extends string>(
  value: string | null | undefined,
  enumType: Record<string, T>,
  defaultValue: T,
  enumName: string
): T {
  if (!value) return defaultValue;

  // Проверяем, есть ли значение в enum
  const enumValues = Object.values(enumType);
  if (enumValues.includes(value as T)) {
    return value as T;
  }

  // Если нет, логируем и возвращаем дефолт
  console.warn(`Unknown ${enumName} value: "${value}", using default: "${defaultValue}"`);
  return defaultValue;
}

 